export default "__VITE_ASSET__BdSVcqC3__"